<template>
  <el-dialog
    title="提示"
    :visible="dialog.state"
    width="30%"
    :center="true"

  >
    <div>请输入自定义标题</div>
    <div>
      <!-- eslint-disable-next-line vue/no-mutating-props -->
      <el-input maxlength="20" v-model="dialog.inputValue"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- eslint-disable-next-line vue/no-mutating-props -->
      <el-button @click="dialog.state = false">取 消</el-button>
      <el-button type="primary" @click="changeCustomTitle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditTitleDialog',
  data() {
    return {}
  },
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  methods: {
    changeCustomTitle() {
      this.$emit('changeCustomTitle')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
</style>
